/**
 * @generated SignedSource<<e39aeea6ef6800e2dec30e23bc503700>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlexibleProjectProgress_project$data = {
  readonly progress: {
    readonly completedCount: number;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "FlexibleProjectProgress_project";
};
export type FlexibleProjectProgress_project$key = {
  readonly " $data"?: FlexibleProjectProgress_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlexibleProjectProgress_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlexibleProjectProgress_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectProgress",
      "kind": "LinkedField",
      "name": "progress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completedCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Project",
  "abstractKey": null
};

(node as any).hash = "a2cfd158faaf533eed64347e82e3e4d9";

export default node;
